import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { DataService } from '../services/data.service';

@Injectable()
export class MainGuard implements CanActivate {
  constructor(private data: DataService, private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {

    if (!this.data.userIsValid()) {
      this.router.navigate(['/login'], {
        queryParams: {
          return: state.url
        }
      });

      return false;
    }
    return true;
  }
}
